import React from "react";
import InputNumber from "./input-number";
import InputText from "./input-text";
import InputMultiEmail from "./input-multi-email";

export default function OrganizationForm(props) {

    return (
        <>
            <form>
                <div css="margin-top: 15px;">
                    <InputText
                        id={"orgName"}
                        label={"Organization name"}
                        value={props.name}
                        onChange={(value) => { props.setName(value) }}
                        hasError={props.nameHasError}
                        errorText={props.nameErrorText}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputMultiEmail
                        id={"orgAdminEmails"}
                        label={"Admin emails"}
                        value={props.orgAdmins}
                        onChange={(value) => { props.setOrgAdmins(value) }}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputText
                        id={"orgPlan"}
                        label={"Organization plan"}
                        value={props.plan}
                        onChange={(value) => { props.setPlan(value) }}
                        hasError={false}
                        errorText={''}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputNumber
                        id={"executionAllowedPerMonth"}
                        fullWidth={true}
                        label={"Execution allowed per month"}
                        value={props.executionAllowedPerMonth}
                        allowDecimal={false}
                        onChange={(value) => { props.setExecutionAllowedPerMonth(value) }}
                        hasError={false}
                        errorText={''}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputNumber
                        id={"allowedEngagements"}
                        fullWidth={true}
                        label={"Allowed engagements"}
                        value={props.allowedEngagements}
                        allowDecimal={false}
                        onChange={(value) => { props.setAllowedEngagements(value) }}
                        hasError={false}
                        errorText={''}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputNumber
                        id={"allowedUsers"}
                        fullWidth={true}
                        label={"Allowed users"}
                        value={props.allowedUsers}
                        allowDecimal={false}
                        onChange={(value) => { props.setAllowedUsers(value) }}
                        hasError={false}
                        errorText={''}
                    />
                </div>
            </form>
        </>
    )
}